<div class="flex flex-col h-full w-full gap-4">
  @if (!hideTabs) {
    <div class="overflow-x-auto">
      <div class="fiche-tabs-container !ml-0 !w-max">
        @for (doc of documents; track (doc.file_id ?? doc.document_id)) {
          <button
            type="button"
            class="fiche-tab"
            [class.active]="activeDocumentId() === ('' + (doc.file_id ?? doc.document_id))"
            (click)="selectDocument('' + (doc.file_id ?? doc.document_id))"
            [disabled]="isLoadingFile()">
            {{ doc.document_name_fr || doc.document_type || doc.file_name }}
          </button>
        }
      </div>
    </div>
  }

  <div class="flex-1 min-h-0 bg-white">
    @if (isLoading()) {
      <div class="flex justify-center items-center h-full">
        <div class="flex flex-col items-center">
          <div class="w-10 h-10 border-4 border-stone-200 border-t-primary-600 rounded-full animate-spin"></div>
          <p class="mt-4 text-stone-500">Chargement du document...</p>
        </div>
      </div>
    }

    @if (!isLoading()) {
      <app-document-viewer
        [document]="activeDocument()"
        [fileUrl]="fileUrl()"
        [isLoading]="isLoadingFile()"
        [error]="error()"
        (onDownload)="downloadDocument()"
        (onClose)="closeViewer()">
      </app-document-viewer>
    }
  </div>
</div>
